var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureNewItem = function SvgFeatureNewItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "miter",
    strokeWidth: 1.25,
    d: "M15.5 5.69c.395 1.415.965 2.697 1.673 3.783.871 1.335 1.971 2.4 3.23 3.027-1.259.627-2.359 1.692-3.23 3.027-.708 1.086-1.278 2.368-1.673 3.783-.395-1.415-.965-2.697-1.673-3.783-.871-1.335-1.971-2.4-3.23-3.027 1.259-.627 2.359-1.692 3.23-3.027.708-1.086 1.278-2.368 1.673-3.783Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "miter",
    d: "M5 9.005a6.975 6.975 0 0 0-.756-1.525c-.41-.616-.918-1.13-1.499-1.48.581-.35 1.089-.864 1.5-1.48.3-.452.555-.965.755-1.525.2.56.454 1.073.756 1.525.41.616.918 1.13 1.499 1.48-.581.35-1.089.864-1.5 1.48A6.975 6.975 0 0 0 5 9.005Z"
  })));
};
export default SvgFeatureNewItem;